module.exports = __webpack_public_path__ + "static/media/secondPartImg1.81fbe6c9.png";